// 定义内容
export default {
	login: {
		placeholder1: '用戶名admin或不輸均為test',
		placeholder2: '密碼：123456',
		placeholder3: '請輸入驗證碼',
		btnText: '登 录',
		link: {
			one1: '協力廠商登入',
			one2: '友情連結',
		},
		signInText: '歡迎回來！',
		copyright: {
			one5: '版權所有：深圳市xxx軟件科技有限公司',
			two6: 'Copyright: Shenzhen XXX Software Technology 粵ICP備05010000號',
		},
	},
};
